import {useAppSelector} from '@/hooks';

export function useGetNumberOfActiveItems(): number {
  const currentPageId = window.posterEditor?.whiteboard?.getCurrentPageId();

  return useAppSelector((state) => {
    if (!currentPageId) {
      return 0;
    }

    if (!state.posterEditor.activeItemIds[currentPageId]) {
      return 0;
    }

    return state.posterEditor.activeItemIds[currentPageId].length;
  });
}
